import {Flex, FlexProps, Image} from '@chakra-ui/react';

import {VisaIcon, MasterCardIcon, ValULogo, FawryLogo} from '@eksab/features/packages/icons';

export const PaymentProviders = (props: FlexProps) => {
  return (
    <Flex
      align="center"
      wrap="wrap"
      gap="2"
      sx={{'> *': {height: [6, 9, 10], width: 'auto', maxW: [10, 12, 14], objectFit: 'contain'}}}
      {...props}
    >
      <VisaIcon width="auto" height="8" />
      <MasterCardIcon width="auto" height="8" />
      <Image src={ValULogo.src} alt="ValU" />

      <Image src={FawryLogo.src} alt="Fawry" />

      <Image src="/images/wallet/vf.png" alt="Vodafone Cash" />
      <Image src="/images/wallet/we.png" alt="We Pay" />
      <Image src="/images/wallet/orange.png" alt="Orange Pay" />
      <Image src="/images/wallet/etisalat.png" alt="Etisalat Cash" />
    </Flex>
  );
};
